import { IAuthGuideManagerInjectable } from '@src/slide/application/service/auth-guide-manager/core/auth-guide-manager.interface';
import { ENV } from '@src/slide/application/service/edit-extension/edit-extension-export';
import { WidgetConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { setDefaultConfig } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { isPreview } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import { appConfigInstance } from '@tencent/docs-connection';

export class AuthGuideManagerInjectable implements IAuthGuideManagerInjectable {
    public get shouldListenAuthGuide(): boolean {
        // 预览态不触发权限引导
        return !isPreview();
    }

    public get shouldListenLoginGuide(): boolean {
        // 本地编辑和预览态不触发登录引导
        return !ENV.IS_PC_LOCAL_EDIT && !isPreview();
    }

    public get shouldShowNoAuthGuide(): boolean {
        return !setDefaultConfig(appConfigInstance.getConfig(WidgetConfig.appGuide), undefined);
    }
}
